// Options for every pdf.js document load. Lives outside src/index.tsx so components
// can import it without pulling in the app bootstrap; index.tsx re-exports it.
export const pdfOptions = {
	// cMapUrl: new URL('pdfjs-dist/cmaps/', import.meta.url).toString(),
	cMapPacked: true,
	// standardFontDataUrl: new URL(
	// 	'pdfjs-dist/standard_fonts/',
	// 	import.meta.url,
	// ).toString(),
};
